import { cn } from '@/lib/cn';
import { inicialesDe } from '@/lib/negocio';
import { aHex, tonosDeMarca } from '@/lib/marca';

/**
 * El sello del negocio: su LOGO si lo tiene (punto 11, en un cuadro blanco para que se lea en
 * claro y en oscuro) o, si no, sus iniciales en un cuadro de esquinas redondas. Se lee con el
 * nombre entero. Las iniciales van en el lleno del acento (el del negocio activo); con `color`, en
 * el de ESE cliente (la lista de todos los Conversia y el selector, donde cada fila es otro
 * negocio). Letra blanca o negra, ≥ 4,5:1. `className` ajusta el tamaño (p. ej. el selector).
 */
export function Sello({
  nombre,
  grande = false,
  color,
  logo,
  className,
}: {
  nombre: string;
  grande?: boolean;
  color?: string | null;
  logo?: string | null;
  className?: string;
}) {
  const t = color ? tonosDeMarca(color) : null;
  const caja = cn(
    'grid shrink-0 place-items-center overflow-hidden',
    grande ? 'h-14 w-14 rounded-2xl text-lg' : 'h-9 w-9 rounded-xl text-xs',
    className,
  );
  if (logo) {
    return (
      <span className={cn(caja, 'bg-white ring-1 ring-inset ring-black/10')}>
        <img src={logo} alt={nombre} className="h-full w-full object-contain" />
      </span>
    );
  }
  return (
    <span
      role="img"
      aria-label={nombre}
      className={cn(caja, 'bg-acento-lleno font-bold tracking-wide text-acento-sobre')}
      style={t ? { background: aHex(t.lleno), color: aHex(t.letra) } : undefined}
    >
      {inicialesDe(nombre)}
    </span>
  );
}
